// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__COwkz","tabsBox":"styles_tabsBox__262Df","createButton":"styles_createButton__1Qpp0"};